import { React } from 'react';

// project-imports
import { slugify, slugifyV2 } from '../../utils';

// third-party
import { Link } from 'react-router-dom';
import Image from '../../common/footer/Images/Image';

const PostOne = ({ data, classes, bgWhite }) => {

    return (
        <div className={`edu-blog blog-type-2 radius-small ${classes ? classes : ''} ${bgWhite === 'enable' ? 'bg-color-white' : ''}`}>
            <div className="inner">
                <div className="thumbnail">
                    <div className="w-100 ratio ratio-16x9 h-100">
                        <Link to={process.env.PUBLIC_URL + `/blog-details/${slugifyV2(data?.title)}`}>
                            <Image src={data?.image} alt="featured" fill />
                        </Link>
                    </div>
                </div>
                <div className="content">
                    <div className="status-group">
                        <Link className="eduvibe-status status-05" to={process.env.PUBLIC_URL + `/category/${slugifyV2(data?.categories?.slice(0, 1))}`}></Link>
                    </div>
                    <h5 className="title text-truncate">
                        <Link to={process.env.PUBLIC_URL + `/blog-details/${slugifyV2(data?.link)}`} dangerouslySetInnerHTML={{ __html: data.title }} ></Link>

                    </h5>
                    <div className="blog-card-bottom">
                        <ul className="blog-meta">
                            <li><i className="icon-calendar-2-line"></i>{data.blogDate}</li>
                        </ul>
                        <div className="read-more-btn">
                            <Link className="btn-transparent" to={process.env.PUBLIC_URL + `/blog-details/${slugifyV2(data?.link)}`}>Read More<i className="icon-arrow-right-line-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PostOne;